/** @jsxImportSource theme-ui @jsxRuntime classic */
import { useLocation } from '@reach/router';
import React, { Fragment } from 'react';

import { Flex, Container, Divider } from '..';

import {
  FooterWifi,
  FooterMenu,
  FooterSubNav,
  FooterContact,
  FooterFollowUs,
  FooterMenuProps,
  FooterSubNavProps,
  FooterEmailSignup,
  FooterAppDownload,
  FooterContactProps,
  FooterFollowUsProps,
  FooterAppDownloadProps,
  FooterEmailSignupProps,
} from './index';

export type FooterProps = FooterSubNavProps &
  FooterContactProps &
  FooterFollowUsProps &
  FooterAppDownloadProps &
  FooterEmailSignupProps &
  FooterMenuProps;

const BUY_TICKETS_REGEX_ARRAY = [
  /\/buy-tickets\/.+/,
  /\/tickets-kaufen\/.+/,
  /\/comprar-boletos\/.+/,
  /\/acheter-des-billets\/.+/,
  /\/comprare-biglietti\/.+/,
  /\/%E3%83%81%E3%82%B1%E3%83%83%E3%83%88%E3%82%92%E8%B2%B7%E3%81%86\/.+/,
  /\/%ED%8B%B0%EC%BC%93-%EA%B5%AC%EB%A7%A4%ED%95%98%EA%B8%B0\/.+/,
  /\/comprar-ingressos\/.+/,
  /\/%E4%B9%B0%E7%A5%A8\/.+/,
  /\/%E8%B2%B7%E7%A5%A8\/.+/,
];

export function Footer({
  links,
  address,
  twitter,
  facebook,
  instagram,
  copyright,
  phoneNumberOne,
  phoneNumberTwo,
  footerContactSubNavLinks,
  logo,
  appStore,
  googlePlay,
  rocklistUrl,
  menuLinks,
}: FooterProps): React.JSX.Element {
  const location = useLocation();

  return (
    <Container sx={{ bg: 'background', maxWidth: 1400 }}>
      {!BUY_TICKETS_REGEX_ARRAY.some((regex) =>
        regex.test(location.pathname),
      ) && (
        <Fragment>
          <Flex
            sx={{
              p: ['32px 0', '32px 32px 32px 0'],
              alignItems: 'baseline',
              flexWrap: ['nowrap', 'wrap'],
              flexDirection: ['column', 'row'],
              justifyContent: 'space-between',
            }}
          >
            <FooterEmailSignup rocklistUrl={rocklistUrl} />
            <FooterFollowUs
              facebook={facebook}
              instagram={instagram}
              twitter={twitter}
            />
            <FooterAppDownload appStore={appStore} googlePlay={googlePlay} />
          </Flex>
          <FooterWifi />
          <Divider sx={{ color: 'LIGHT_GRAY' }} />
          <FooterMenu menuLinks={menuLinks} />
          <Divider
            sx={{ color: 'LIGHT_GRAY', display: ['flex', null, null, 'none'] }}
          />
          <FooterSubNav links={links} logo={logo} />
          <Divider sx={{ display: ['none', null, null, 'flex'] }} />
        </Fragment>
      )}
      <FooterContact
        address={address}
        copyright={copyright}
        footerContactSubNavLinks={footerContactSubNavLinks}
        phoneNumberOne={phoneNumberOne}
        phoneNumberTwo={phoneNumberTwo}
        sx={
          BUY_TICKETS_REGEX_ARRAY.some((regex) => regex.test(location.pathname))
            ? { borderTop: 'none !important' }
            : {}
        }
      />
    </Container>
  );
}
